import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@vadiun/react-components';
import { useVerifyAction } from '@vadiun/react-hooks-legacy';
import { Table } from 'shared/components';
import { AuthorizedModel } from '../models/Authorized';

interface Props {
  authorizeds: AuthorizedModel[];
  selectToEdit: (x: AuthorizedModel) => void;
  delete: (x: AuthorizedModel) => void;
}

const AuthorizedTable = (props: Props) => {
  const verifyAction = useVerifyAction();

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
        sort: true
      }
    },

    {
      name: 'phone',
      label: 'Teléfono',
      options: {
        filter: false,
        sort: true
      }
    },

    {
      name: 'email',
      label: 'Email',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      label: 'Acciones',
      name: 'id',
      options: {
        filter: false,
        customBodyRenderLite: (index: number) => (
          <div style={{ display: 'flex' }}>
            <Button
              onClick={() => props.selectToEdit(props.authorizeds[index])}
              shape="circle"
              color="primary"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </Button>
            <Button
              onClick={() =>
                verifyAction({
                  title: '¡Estás por eliminar un autorizado!',
                  body: 'Esta acción va a eliminar el autorizado. ¿Estás seguro?',
                  onAccept: () => props.delete(props.authorizeds[index])
                })
              }
              shape="circle"
              color="red"
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
        )
      }
    }
  ];

  const data = props.authorizeds.map((x) => ({
    ...x
  }));

  return (
    <div className="w-full">
      <Table
        options={{
          elevation: 0,
          selectableRows: 'none'
        }}
        title={'Autorizados'}
        data={data}
        columns={columns}
      />
    </div>
  );
};

export default AuthorizedTable;
